module.exports = __webpack_public_path__ + "img/1F60B.fcccc7ae.svg";